import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_number_value = _resolveComponent("number-value");
  return _openBlock(), _createBlock(_component_number_value, {
    class: "hashed-number-value",
    value: $props.value,
    tight: "",
    charCount: $props.charCount + $props.prepend.length,
    prepend: $props.prepend
  }, null, 8, ["value", "charCount", "prepend"]);
}